import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Card, CardSection, Flex, IconSvg } from '@/lib/v2/components';
import { SectionHeader } from '@/lib/v2/examples/SectionHeader';
import { CreateIcon } from '@/lib/v2/icons/outline';

import CreateActionsModal from '@/src/modules/CampaignsModule/components/CampaignActions/CreateActions/CreateActionsModal';
import { HeaderBannerActions } from '@/src/modules/CampaignsModule/components/CampaignActions/HeaderBannerActions';
import { TableContainer } from '@/src/modules/CampaignsModule/components/CampaignActions/TableContainer';
import { CreateEditCampaigns } from '@/src/modules/CampaignsModule/components/CampaignsModal';
import { SectionHeaderSubtitle } from '@/src/modules/CampaignsModule/components/SectionHeaderSubtitle';
import { useActionsData } from '@/src/modules/CampaignsModule/hooks/useActionsData';
import { useCampaignModal } from '@/src/modules/CampaignsModule/hooks/useCampaignModal';
import { useResetAtomOnUnmount } from '@/src/modules/CampaignsModule/hooks/useResetAtomOnUnmount';

const CampaignActionsMain = () => {
  const { t } = useTranslation();

  const [actionCreationsModalIsOpen, setActionCreationsModalIsOpen] = useState(false);
  const { actionsList, loadingProcess, totalsActionsList, filtersCount } = useActionsData();
  const { resetAtomProcess } = useResetAtomOnUnmount();
  const { handleOnCloseModal, toggleEditCreateCampaignModal } = useCampaignModal();

  useEffect(() => {
    return () => {
      resetAtomProcess();
    };
  }, []);

  const handleCreateCampaignAction = () => {
    setActionCreationsModalIsOpen(true);
  };

  const handleCloseActionCreationsModal = useCallback(() => {
    setActionCreationsModalIsOpen(false);
  }, []);

  return (
    <>
      <CreateActionsModal
        isOpen={actionCreationsModalIsOpen}
        onClose={handleCloseActionCreationsModal}
      />
      <Card className="mb-4">
        <HeaderBannerActions />
      </Card>
      <Card>
        <CardSection noPadding>
          <Flex column>
            <SectionHeader
              actionsButtons={
                <Button
                  iconLeft={<IconSvg strokeColor="white" svgComponent={<CreateIcon />} />}
                  id="create-campaign-actions-button"
                  size="small"
                  onClick={handleCreateCampaignAction}
                >
                  {t('CAMPAIGN_ACTIONS_MAIN.button')}
                </Button>
              }
              subtitle={
                <SectionHeaderSubtitle
                  countFilters={filtersCount}
                  countRecordsPartial={totalsActionsList.partial}
                  dataList={actionsList}
                  i18nKey="CAMPAIGN_ACTIONS_MAIN.search"
                  loading={loadingProcess}
                />
              }
              title={t('CAMPAIGN_ACTIONS_MAIN.title')}
              titleDetail={`${totalsActionsList.total ? `(${totalsActionsList.total || 0})` : ''}`}
            />
            <Flex column withGap gapSize="medium">
              <TableContainer />
            </Flex>
          </Flex>
        </CardSection>
      </Card>
      {toggleEditCreateCampaignModal && <CreateEditCampaigns onClose={handleOnCloseModal} />}
    </>
  );
};

export default CampaignActionsMain;
